import { Close } from '@mui/icons-material';
import { Box, Stack, styled } from '@mui/material';
import { Chip, colorPaletteLight } from '@sb/cc-design-system';

export const OverflowFilterChipList = styled(Stack)`
  flex: 1;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
  padding: 12px 0 12px 8px;
`;

export const OverflowFilterChip = styled(Chip)`
  background-color: ${colorPaletteLight.secondary.info.subtle};
  flex-shrink: 0;
`;

export const HiddenChipMeasureBox = styled(Box)`
  height: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 0;
  white-space: nowrap;
`;

export const HiddenChipMeasureStack = styled(Stack)`
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 8px;
`;

export const CloseIconPointer = styled(Close)`
  cursor: pointer;
`;
